var _defs, _rect, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarWaves(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 260 900",
    preserveAspectRatio: "xMidYMax slice",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sheen",
    x1: 0,
    y1: 1,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffffff",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#ffffff",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "deep",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d0716",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3d0716",
    stopOpacity: 0.35
  })), /*#__PURE__*/React.createElement("filter", {
    id: "soft",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 450,
    width: 260,
    height: 450,
    fill: "url(#deep)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#soft)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 520 C 90 560 190 660 260 820 L 260 900 L 0 900 Z",
    fill: "url(#sheen)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 640 C 110 670 200 760 250 900 L 0 900 Z",
    fill: "url(#sheen)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#ffffff",
    strokeLinecap: "round",
    opacity: 0.12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-10 560 C 90 590 190 690 262 860",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-10 680 C 100 705 190 790 238 900",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-10 460 C 80 500 170 590 262 740",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarWaves);
export default __webpack_public_path__ + "static/media/sidebar-waves.9f1a5117155f9821cf432942e9e130e7.svg";
export { ForwardRef as ReactComponent };